module.exports = __webpack_public_path__ + "img/telephone.0a97f4f7.svg";